{{#if todoRandomInstanceVariables.length}}
/*
{{#each todoRandomInstanceVariables delimeter="\n"}}
constraint {{ ../constraintPrefix }}{{ identifier }}_crv {
  {{ ../todoInstanceVariablePrefix }}{{ identifier }} <TODO>;
}
{{/each}}
*/
{{/if}}
